import { Box, ChakraProps } from '@chakra-ui/react'
import { FC } from 'react'

// コンテンツの高さがページの高さに足りない場合に、Footerの上のスペースを埋めるためのコンポーネント
export const PagePadding: FC<{} & ChakraProps> = ({ ...props }) => {
  return <Box flexGrow="1" minHeight="96px"></Box>
}
